import { createRoot } from 'react-dom/client';
import { LicenseInfo } from '@mui/x-license';
import App from './App';
import { runtimeEnv } from './config/runtimeEnv';

if (runtimeEnv.muiXLicenseKey) {
  LicenseInfo.setLicenseKey(runtimeEnv.muiXLicenseKey);
}

const container = document.getElementById('root');
const root = createRoot(container as HTMLElement);
root.render(<App />);
